import React, { useEffect, useState } from "react";
import { Filter, FloatRight, FormView, PagesHeader } from "../../components/Staffs";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {  getStaffInfo, getStaffsList } from "../../appRedux/actions/staffs";
import Page from "../../components/Common/Page";
import { getFreeCurrencyApi } from "../../appRedux/actions/common";
import { useParams } from "react-router-dom";

const StaffUpdate = () => {
  const { staffId } = useParams();
  const dispatch = useDispatch();
  const [initialFetchComplete, setInitialFetchComplete] = useState(false);

  const [viewStatus, setViewStatus] = useState("listView"); //"listView", "gridView"
  const staffList = useSelector((state) => state.staffs.staffList);
  console.log({ staffList });

  useEffect(() => {
    dispatch(getStaffInfo(staffId));
  }, [staffId]);
  useEffect(() => {
    

    dispatch(getFreeCurrencyApi());
  }, [dispatch]);
  return (
    <Page title="Staff">
      <div className="page-wrapper">
        {/* Page Content */}
        <div className="content container-fluid">
          {/* Page Header */}
          <PagesHeader
            pageTitle={"Staff Update"}
            homePageUrl="/"
            homePageText="Dashboard"
            innerPageUrl={"/staff/list"}
            innerPageText={"Staff List"}
            activePageText={"Update Staff"}
            floatRight={""}
          />
          <div className="card">
            <div className="card-body">
              <FormView isUpdate={true} />
            </div>
          </div>
        </div>
        {/* /Page Content */}
      </div>
    </Page>
  );
};

export default StaffUpdate;
